<div class="card p-3 mb-3" [attr.id]="'post-' + (post?.id ?? post?.uuid)">
  <!-- Header -->
  <div class="d-flex align-items-center justify-content-between mb-2">
    <div
      class="d-flex align-items-center"
      [class.cursor-pointer]="!!post?.Users?.id"
      (click)="post?.Users?.id && openProfile(post.Users.id)"
    >
      <img
        [src]="getAuthorAvatar()"
        class="rounded-circle me-2"
        width="40"
        height="40"
        alt="avatar"
      />

      <div>
        <div class="d-flex align-items-center gap-2 flex-wrap">
          <strong class="text-primary fw-semibold mb-0">
            {{ getAuthorName() }}
          </strong>

          <ng-container *ngIf="post.post_type === 'job'">
            <span
              *ngIf="isJobExpired(); else jobBadge"
              class="badge bg-danger text-white ms-2"
            >
              Expired
            </span>

            <ng-template #jobBadge>
              <span class="badge bg-warning text-dark ms-2">Job</span>
            </ng-template>
          </ng-container>

          <!-- Availability (only when we have a jobseeker) -->
          <span
            class="badge rounded-pill px-2 py-1"
            *ngIf="post?.Users?.Jobseekers?.[0]?.availability as av"
            [ngClass]="getAvailabilityBadgeClass(av)"
          >
            {{ getAvailabilityStatus(av) }}
          </span>
        </div>

        <!-- Designation (only when we have a jobseeker) -->
        <span
          class="text-secondary d-block"
          *ngIf="post?.Users?.Jobseekers?.[0]?.designation as desig"
        >
          {{ desig }}
        </span>

        <!-- Timestamp (safe) -->
        <ng-container *ngIf="isNews; else nonNewsTime">
          <small class="text-muted" *ngIf="getNewsPublishedAt() as publishedAt">
            {{ publishedAt | timeAgoOrDate }}
          </small>
        </ng-container>
        <ng-template #nonNewsTime>
          <small class="text-muted">
            {{ post.created_at | timeAgoOrDate }}
          </small>
        </ng-template>
      </div>
    </div>

    <!-- Dropdown for Edit/Delete -->
   <div *ngIf="canEditDeletePost" class="dropdown">
      <button
        class="btn btn-sm btn-light"
        type="button"
        data-bs-toggle="dropdown"
        aria-expanded="false"
      >
        <i class="bi bi-three-dots-vertical"></i>
      </button>
      <ul class="dropdown-menu dropdown-menu-end">
        <li><button class="dropdown-item" (click)="onEdit()">Edit</button></li>
        <li>
          <button class="dropdown-item text-danger" (click)="onDelete()">
            Delete
          </button>
        </li>
      </ul>
    </div>
  </div>

  <!-- Content -->

  <!-- Job post layout -->
  <div class="mb-2" *ngIf="post.post_type === 'job'; else nonJobOrNews">
    <ng-container *ngIf="parseJob(post.content) as job">
      <div class="fw-semibold fs-6 text-dark">{{ job.title || "Job" }}</div>

      <div class="mb-2" *ngIf="job.description"></div>

      <div *ngIf="job.description" class="text-body job-description">
  {{ job.description }}
</div>

      <div class="mb-2" *ngIf="job.description"></div>

      <div class="text-muted small job-meta">
        <div
          *ngIf="job.location"
          class="d-flex align-items-center mb-1 meta-row"
        >
          <i class="bi bi-geo-alt me-2 lh-1 flex-shrink-0 meta-icon"></i>
          <span class="fw-semibold me-1">Location:</span>
          <span>{{ job.location }}</span>
        </div>

        <div
          *ngIf="job.startDate"
          class="d-flex align-items-center mb-1 meta-row"
        >
          <i class="bi bi-calendar-event me-2 lh-1 flex-shrink-0 meta-icon"></i>
          <span class="fw-semibold me-1">Start date:</span>
          <span>{{ job.startDate }}</span>
        </div>

        <div *ngIf="job.duration" class="d-flex align-items-center meta-row">
          <i
            class="bi bi-hourglass-split me-2 lh-1 flex-shrink-0 meta-icon"
          ></i>
          <span class="fw-semibold me-1">Duration:</span>
          <span>{{ job.duration }}</span>
        </div>
      </div>
    </ng-container>
  </div>

  <ng-template #nonJobOrNews>
    <!-- ===== NEWS CARD ===== -->
    <div class="news-card" *ngIf="isNews; else maybeLinkPreview">
      <a
        class="stretched-link text-decoration-none"
        *ngIf="getNewsUrl() as newsUrl"
        [href]="newsUrl"
        target="_blank"
        rel="noopener nofollow"
        [attr.aria-label]="post.news?.title || post.content"
      ></a>

      <div class="news-grid">
        <div class="news-text">
          <div class="news-source-line">
            <img
              class="news-favicon"
              *ngIf="domainOf(getNewsUrl()) as favDomain"
              [src]="
                'https://www.google.com/s2/favicons?domain=' +
                favDomain +
                '&sz=32'
              "
              alt="source icon"
              loading="lazy"
              referrerpolicy="no-referrer"
            />
            <span class="news-source">
              {{ getNewsSourceLabel() }}
            </span>
            <span class="news-dot" *ngIf="getNewsPublishedAt()">•</span>
            <span class="news-time" *ngIf="getNewsPublishedAt() as pubAt">
              {{ pubAt | date: "short" }}
            </span>
          </div>

          <h3 class="news-title mb-1">
            {{ post.news?.title || post.content }}
          </h3>

          <div class="news-actions" *ngIf="getNewsUrl()">
            <span class="news-chip">Read on web</span>
          </div>
        </div>

        <div
          class="news-media"
          *ngIf="post.news?.image_url || post.news_image_url"
        >
          <img
            class="news-image"
            [src]="post.news?.image_url || post.news_image_url"
            alt="news image"
            loading="lazy"
          />
        </div>
      </div>
    </div>

    <!-- ===== NON-NEWS POSTS WITH OPTIONAL LINK PREVIEW ===== -->
    <ng-template #maybeLinkPreview>
      <ng-container *ngIf="splitContentAndFirstUrl(post.content) as withUrl">
        <!-- If there is a URL in the content -->
        <ng-container *ngIf="withUrl.url as url; else normalContent">
          <!-- Body text (without the URL) -->
          <div class="mb-2" *ngIf="withUrl.content.trim().length > 0">
            <span *ngIf="!expanded">
              <span
                class="rich-text"
                [innerHTML]="sanitizeAndLinkify(withUrl.content, 400)"
              ></span>
              <span *ngIf="(withUrl.content.length || 0) > 400">
                …
                <a
                  (click)="toggleExpand()"
                  class="text-primary text-decoration-none"
                  >See more</a
                >
              </span>
            </span>
            <span *ngIf="expanded">
              <span
                class="rich-text"
                [innerHTML]="sanitizeAndLinkify(withUrl.content)"
              ></span>
              <a
                (click)="toggleExpand()"
                class="text-primary text-decoration-none ms-2"
                >See less</a
              >
            </span>
          </div>

          <!-- Link preview card -->
          <div class="news-card">
            <ng-container
              *ngIf="linkPreview && linkPreview[post.id] as lp; else lpInit"
            >
              <!-- Loading skeleton/state -->
              <div class="news-grid" *ngIf="lp.loading">
                <div class="news-text">
                  <div class="news-source-line">
                    <span class="news-source text-muted">Loading preview…</span>
                  </div>
                  <h3 class="news-title mb-1 placeholder-glow">
                    <span class="placeholder col-8"></span>
                  </h3>
                  <div class="news-actions">
                    <span class="news-chip">Please wait</span>
                  </div>
                </div>
                <div class="news-media d-none d-sm-block">
                  <div class="ratio ratio-16x9 bg-light placeholder"></div>
                </div>
              </div>

              <!-- Error / denied host fallback -->
              <div class="news-grid" *ngIf="!lp.loading && !lp.data">
                <div class="news-text">
                  <div class="news-source-line">
                    <img
                      class="news-favicon"
                      *ngIf="domainOf(url) as d2"
                      [src]="
                        'https://www.google.com/s2/favicons?domain=' +
                        d2 +
                        '&sz=32'
                      "
                      alt="source icon"
                      loading="lazy"
                      referrerpolicy="no-referrer"
                    />
                    <span class="news-source">{{
                      domainOf(url) || "Link"
                    }}</span>
                  </div>
                  <h3 class="news-title mb-1">
                    {{ stripProtocol(url) }}
                  </h3>
                  <div class="news-actions">
                    <span class="news-chip" *ngIf="lp.error === 'denied-host'"
                      >Preview not available</span
                    >
                    <span class="news-chip" *ngIf="lp.error !== 'denied-host'"
                      >Open link</span
                    >
                  </div>
                </div>
                <a
                  class="stretched-link text-decoration-none"
                  [href]="url"
                  target="_blank"
                  rel="noopener nofollow"
                  [attr.aria-label]="stripProtocol(url)"
                ></a>
              </div>

              <!-- Success -->
              <div class="news-grid" *ngIf="!lp.loading && lp.data">
                <div class="news-text">
                  <div class="news-source-line">
                    <img
                      class="news-favicon"
                      *ngIf="domainOf(lp.data.url || url) as d"
                      [src]="
                        'https://www.google.com/s2/favicons?domain=' +
                        d +
                        '&sz=32'
                      "
                      alt="source icon"
                      loading="lazy"
                      referrerpolicy="no-referrer"
                    />
                    <span class="news-source">
                      {{
                        lp.data.source || domainOf(lp.data.url || url) || "Link"
                      }}
                    </span>
                  </div>
                  <h3 class="news-title mb-1">
                    {{ lp.data.title || stripProtocol(url) }}
                  </h3>
                  <div class="news-actions">
                    <span class="news-chip">Open link</span>
                  </div>
                </div>
                <div class="news-media" *ngIf="lp.data.image_url">
                  <img
                    class="news-image"
                    [src]="lp.data.image_url"
                    alt="link preview image"
                    loading="lazy"
                  />
                </div>
                <a
                  class="stretched-link text-decoration-none"
                  [href]="lp.data.url || url"
                  target="_blank"
                  rel="noopener nofollow"
                  [attr.aria-label]="lp.data.title || stripProtocol(url)"
                ></a>
              </div>
            </ng-container>

            <!-- State not initialized yet (very first change detection) -->
            <ng-template #lpInit>
              <div class="news-grid">
                <div class="news-text">
                  <div class="news-source-line">
                    <span class="news-source text-muted">Loading preview…</span>
                  </div>
                  <h3 class="news-title mb-1 placeholder-glow">
                    <span class="placeholder col-7"></span>
                  </h3>
                </div>
                <div class="news-media d-none d-sm-block">
                  <div class="ratio ratio-16x9 bg-light placeholder"></div>
                </div>
              </div>
            </ng-template>
          </div>
        </ng-container>

        <!-- No URL in content -->
        <ng-template #normalContent>
          <div class="mb-2">
            <span *ngIf="!expanded">
              <span
                class="rich-text"
                [innerHTML]="sanitizeAndLinkify(post.content, 400)"
              ></span>
              <span *ngIf="(post.content?.length || 0) > 400">
                …
                <a
                  (click)="toggleExpand()"
                  class="text-primary text-decoration-none"
                  >See more</a
                >
              </span>
            </span>
            <span *ngIf="expanded">
              <span
                class="rich-text"
                [innerHTML]="sanitizeAndLinkify(post.content)"
              ></span>
              <a
                (click)="toggleExpand()"
                class="text-primary text-decoration-none ms-2"
                >See less</a
              >
            </span>
          </div>
        </ng-template>
      </ng-container>
    </ng-template>
  </ng-template>

  <!-- Attachments -->
  <div *ngIf="post.CommunityPostAttachment?.length" class="row g-2 mb-2">
    <div
      class="col-4 col-sm-3 col-md-2"
      *ngFor="let att of post.CommunityPostAttachment; let i = index"
    >
      <img
        [src]="att.thumbnail_url || att.file_url"
        class="img-thumbnail viewer-trigger cursor-pointer"
        (click)="openImageViewer('attachments', i)"
        alt="attachment"
        loading="lazy"
      />
    </div>
  </div>

  <!-- Actions area -->
  <div class="d-flex gap-2 flex-wrap mb-2">
    <!-- JOB POST -->
<ng-container *ngIf="post.post_type === 'job'; else nonJobActions">
  <ng-container *ngIf="isOwner  ; else notOwnerJob">
    <span class="badge bg-light text-dark border" *ngIf="!isKARecruiterJobPost" >
      Applications: {{ post._count?.replies || 0 }}
    </span>

    <button
      class="btn btn-sm btn-lite-blue"
      (click)="goToApplicantList()"
      [disabled]="!(post._count?.replies) || isJobExpired()"
      *ngIf="!isKARecruiterJobPost"
    >
      View Applications ({{ post._count?.replies || 0 }})
    </button>
    <button
      class="btn btn-sm btn-lite-blue"
      (click)="goToApplicantList()"
      [disabled]="isJobExpired()"
      *ngIf="isKARecruiterJobPost"
    >
      View Applications 
    </button>

    <button
      *ngIf="isKARecruiterJobPost"
      class="btn btn-sm btn-lite-blue"
      (click)="replying = !replying"
    >
      {{ replying ? 'Cancel Reply' : 'Reply' }}
    </button>
  </ng-container>

<ng-template #notOwnerJob>
  <!-- Komudu job post apply -->
  <button
    *ngIf="!isOwner && !isRecruiter && !post.has_applied_by_me && !isKARecruiterJobPost"
    class="btn btn-sm btn-lite-blue"
    (click)="onClickApply()"
    [disabled]="isJobExpired()"
  >
    Apply
  </button>

  <!-- KA recruiter job post apply -->
  <button
    *ngIf="!isOwner && !isRecruiter && !post.has_applied_by_me && isKARecruiterJobPost"
    class="btn btn-sm btn-lite-blue"
    (click)="onClickKAApply()"
    [disabled]="isJobExpired()"
  >
    Apply
  </button>

  <!-- Applied badge -->
   <button
    *ngIf="!isOwner && !isRecruiter && post.has_applied_by_me"
    class="btn btn-sm btn-lite-blue-disable"
   disabled
  >
   Applied
   </button>
  <!-- KA recruiter job post reply -->
  <button
    *ngIf="isKARecruiterJobPost"
    class="btn btn-sm btn-lite-blue"
    (click)="replying = !replying"
  >
    {{ replying ? 'Cancel Reply' : 'Reply' }}
  </button>

  <button
    *ngIf="isKARecruiterJobPost"
    class="btn btn-sm btn-lite-blue"
    (click)="onToggleReplies()"
    [disabled]="!post._count?.replies"
  >
    {{ post.showReplies ? 'Hide Replies' : 'Show Replies' }} ({{ post._count?.replies || 0 }})
  </button>
</ng-template>
</ng-container>

    <!-- NON-JOB POST (includes news) -->
    <ng-template #nonJobActions>
      <button
        *ngIf="post.reply_depth < 4"
        class="btn btn-sm btn-lite-blue"
        (click)="replying = !replying"
      >
        Reply
      </button>

      <button
        class="btn btn-sm btn-lite-blue"
        (click)="onToggleReplies()"
        [disabled]="!post._count?.replies"
      >
        {{ post.showReplies ? "Hide Replies" : "Show Replies" }} ({{
          post._count?.replies || 0
        }})
      </button>
    </ng-template>

    <!-- SHARE (always visible) -->
    <button class="btn btn-sm btn-lite-blue" (click)="openShareModal()">
      Share
    </button>
  </div>

  <!-- Inline Reply (NON-JOB) -->
 <div
  *ngIf="replying && (post.post_type !== 'job' || isKARecruiterJobPost)"
  class="mb-3"
  [@slideIn]
>
    <div *ngIf="submittingReplyPostId === post.id" class="text-center my-2">
      <div class="spinner-border text-primary" role="status">
        <span class="visually-hidden">Submitting...</span>
      </div>
    </div>

    <ng-container *ngIf="submittingReplyPostId !== post.id">
      <textarea
        [(ngModel)]="replyContent"
        class="form-control mb-2"
        rows="3"
        maxlength="1000"
        placeholder="Write your reply..."
        style="resize: none"
      ></textarea>
      <small class="text-end d-block text-muted"
        >{{ replyContent.length || 0 }}/1000 characters</small
      >

      <div class="mb-2">
        <i
          class="bi bi-image fs-4 text-primary cursor-pointer"
          (click)="uploadInput.click()"
          title="Upload Images"
        ></i>
        <input
          type="file"
          #uploadInput
          hidden
          multiple
          accept="image/*"
          (change)="onFileChange($event)"
        />
        <small class="text-danger" *ngIf="imageError">{{ imageError }}</small>

        <div *ngIf="isGeneratingPreview" class="text-center my-2">
          <div class="spinner-border text-secondary" role="status">
            <span class="visually-hidden">Generating previews...</span>
          </div>
        </div>

        <div class="mt-2 d-flex flex-wrap gap-2">
          <div
            *ngFor="let img of imagePreviews; let i = index"
            class="position-relative image-preview-wrapper"
          >
            <img
              [src]="img"
              class="preview-image viewer-trigger cursor-pointer"
              (click)="openImageViewer('previews', i)"
              alt="preview"
            />
            <button
              type="button"
              class="btn btn-sm btn-danger delete-btn"
              (click)="removeReplyImage(i)"
              title="Remove"
            >
              ×
            </button>
          </div>
        </div>
      </div>

      <button
        class="btn btn-sm btn-lite-blue me-2"
        (click)="submitPostReply()"
        [disabled]="!replyContent.trim() && imagePreviews.length === 0"
      >
        Submit
      </button>
      <button class="btn btn-sm btn-secondary" (click)="replying = false">
        Cancel
      </button>
    </ng-container>
  </div>

  <!-- Replies -->
  <div class="ms-3 mt-3" *ngIf="post.showReplies">
    <div *ngIf="isLoadingReplies" class="text-center mb-2">
      <div class="spinner-border text-primary" role="status">
        <span class="visually-hidden">Loading...</span>
      </div>
    </div>

    <app-reply-item
      *ngFor="let reply of post.replies"
      [reply]="reply"
      [isMobile]="isMobile"
      [communityID]="communityID"
      (submitReplyToReply)="submitReply.emit($event)"
      [availabiltyDurations]="availabiltyDurations"
    >
    </app-reply-item>
  </div>
</div>

<!-- Profile Modal -->
<ng-template #profileModal let-modal>
  <div class="modal-header border-0 pb-0">
    <h5 class="modal-title fw-semibold">
      {{ selectedUser?.is_public ? selectedUser?.name : "Private User" }}
    </h5>
    <button type="button" class="btn-close" (click)="modal.dismiss()"></button>
  </div>

  <div class="modal-body">
    <div class="d-flex flex-column align-items-center text-center">
      <img
        [src]="
          selectedUser?.is_public && selectedUser?.avatar_url
            ? selectedUser.avatar_url
            : 'https://kontact-app-public.s3-ap-southeast-1.amazonaws.com/images/Sign-Up-Image.jpg'
        "
        class="rounded-circle shadow mb-3"
        style="width: 100px; height: 100px"
        alt="profile avatar"
      />

      <ng-container *ngIf="selectedUser?.is_public; else privateProfile">
        <p *ngIf="selectedUser?.about_me">
          <i class="bi bi-person-lines-fill me-2 text-info"></i>
          <strong>About Me:</strong><br />
          <span class="d-block mt-1">{{ selectedUser.about_me }}</span>
        </p>

        <div *ngIf="selectedUser?.availability" class="mb-3">
          <p class="mb-0">
            <strong>Availability:</strong>
            {{ getAvailabilityStatus(selectedUser.availability) }}
          </p>
        </div>
      </ng-container>

      <ng-template #privateProfile>
        <div class="alert alert-warning w-100 mt-2 text-center">
          This profile is private.
        </div>
      </ng-template>
    </div>
  </div>
</ng-template>

<!-- Image Viewer Modal -->
<ng-template #imageViewerModal let-modal>
  <div class="modal-body text-center p-0">
    <img
      [src]="currentImageUrl"
      class="img-fluid w-100 swipe-img"
      (touchstart)="onTouchStart($event)"
      (touchmove)="onTouchMove($event)"
      (touchend)="onTouchEnd()"
      alt="viewer"
    />
  </div>
  <div class="modal-footer justify-content-between border-0">
    <button class="btn btn-link" (click)="prevImage()" [disabled]="!hasPrev()">
      Prev
    </button>
    <button class="btn btn-link" (click)="nextImage()" [disabled]="!hasNext()">
      Next
    </button>
    <button class="btn btn-danger btn-sm" (click)="modal.close()">Close</button>
  </div>
</ng-template>

<!-- Edit Post Modal -->
<ng-template #editPostModal let-modal>
  <div class="modal-header">
    <h5 class="modal-title">Edit Post</h5>
    <button type="button" class="btn-close" (click)="modal.dismiss()"></button>
  </div>
  <div class="modal-body">
    <textarea
      [(ngModel)]="editedContent"
      (input)="onEditedContentInput()"
      class="form-control"
      rows="5"
      maxlength="1000"
      placeholder="Update your post..."
    ></textarea>

    <small
      *ngIf="post.post_type === 'job' && editedHasLinks"
      class="text-danger d-block mt-1"
    >
      Links and email addresses are not allowed in job posts.
    </small>

    <small class="text-muted d-block text-end mt-1"
      >{{ editedContent.length || 0 }}/1000 characters</small
    >

    <hr />

    <div *ngIf="existingAttachments.length" class="mb-2">
      <p class="fw-semibold mb-1">Existing Images:</p>
      <div class="d-flex flex-wrap gap-2">
        <div
          *ngFor="let att of existingAttachments; let i = index"
          class="position-relative image-preview-wrapper"
        >
          <img
            [src]="att.thumbnail_url || att.file_url"
            class="preview-image"
            alt="existing image"
          />
          <button
            type="button"
            class="btn btn-sm btn-danger delete-btn"
            (click)="removeExistingAttachment(i)"
            title="Remove"
          >
            ×
          </button>
        </div>
      </div>
    </div>

    <div>
      <p class="fw-semibold mb-1">Add Images:</p>
      <i
        class="bi bi-image fs-4 text-primary cursor-pointer"
        (click)="editUploadInput.click()"
        title="Upload Images"
      ></i>
      <input
        type="file"
        #editUploadInput
        hidden
        multiple
        accept="image/*"
        (change)="onEditFileChange($event)"
      />
      <div *ngIf="editImagePreviews.length" class="mt-2 d-flex flex-wrap gap-2">
        <div
          *ngFor="let img of editImagePreviews; let i = index"
          class="position-relative image-preview-wrapper"
        >
          <img [src]="img" class="preview-image" alt="new image" />
          <button
            type="button"
            class="btn btn-sm btn-danger delete-btn"
            (click)="removeNewEditImage(i)"
          >
            ×
          </button>
        </div>
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-secondary" (click)="modal.close()">
      Cancel
    </button>
    <button
      type="button"
      class="btn btn-primary"
      (click)="confirmEdit(modal)"
      [disabled]="
        (!editedContent.trim() &&
          existingAttachments.length === 0 &&
          newEditImages.length === 0) ||
        (post.post_type === 'job' && editedHasLinks)
      "
    >
      Save Changes
    </button>
  </div>
</ng-template>

<!-- Pre-Apply Modal -->
<ng-template #preApplyModal let-modal>
  <div class="modal-header border-0 pb-0">
    <h5 class="modal-title fw-semibold">Complete these before applying</h5>
    <button
      type="button"
      class="btn-close"
      (click)="cancelPreApply()"
      aria-label="Close"
    ></button>
  </div>

  <div class="modal-body">
    <div *ngIf="preApply.checking" class="text-center my-4">
      <div class="spinner-border text-primary" role="status">
        <span class="visually-hidden">Checking…</span>
      </div>
    </div>

    <div
      *ngIf="!preApply.checking && missingCount === 0"
      class="alert alert-success"
    >
      Everything’s up to date. You can proceed to apply.
    </div>

    <div
      *ngIf="!preApply.checking && needsPhone"
      class="card border-0 shadow-sm mb-3"
    >
      <div class="card-body">
        <h6 class="fw-semibold mb-2">Add your phone</h6>

        <form [formGroup]="phoneForm" class="row g-2 align-items-center">
          <div class="col-6 col-md-5">
            <select class="form-select" formControlName="country_code">
              <option [ngValue]="''" disabled>Select code</option>
              <option
                *ngFor="let country of MobileCountries"
                [value]="country.dialCode"
              >
                +{{ country.dialCode }} ({{ country.name }})
              </option>
            </select>
          </div>
          <div class="col">
            <input
              type="tel"
              class="form-control"
              formControlName="phone"
              placeholder="Phone number"
            />
          </div>
          <div class="col-auto">
            <button
              class="btn btn-primary btn-sm btn-lite-blue"
              type="button"
              (click)="savePhoneInline()"
              [disabled]="savingPhone"
            >
              <span *ngIf="!savingPhone">Save</span>
              <span
                *ngIf="savingPhone"
                class="spinner-border spinner-border-sm"
              ></span>
            </button>
          </div>
        </form>

        <small class="text-muted d-block mt-1"
          >We’ll store this on your profile.</small
        >
      </div>
    </div>

    <div
      *ngIf="!preApply.checking && needsCv"
      class="card border-0 shadow-sm mb-3"
    >
      <div class="card-body">
        <h6 class="fw-semibold mb-2">Upload your CV</h6>
        <div class="d-flex align-items-center gap-2 flex-wrap">
          <input
            type="file"
            accept=".pdf,.doc,.docx"
            (change)="onResumeFileChange($event)"
          />
          <button
            class="btn btn-primary btn-sm btn-lite-blue"
            (click)="uploadResumeInline()"
            [disabled]="savingResume || !resumeFile"
          >
            <span *ngIf="!savingResume">Upload</span>
            <span
              *ngIf="savingResume"
              class="spinner-border spinner-border-sm"
            ></span>
          </button>
        </div>
        <small class="text-muted d-block mt-1" *ngIf="resumeFileName">
          Selected: {{ resumeFileName }}
        </small>
        <small class="text-muted d-block">PDF, DOC, or DOCX — max 5 MB.</small>
      </div>
    </div>

    <div
      *ngIf="!preApply.checking && needsAvailability"
      class="card border-0 shadow-sm mb-3"
    >
      <div class="card-body">
        <h6 class="fw-semibold mb-2">
          Update availability
          <small class="text-muted ms-1" *ngIf="preApply.availabilityTooltip">
            ({{ preApply.availabilityTooltip }})
          </small>
        </h6>

        <div class="mb-2">
          <div class="form-check form-check-inline">
            <input
              class="form-check-input"
              type="radio"
              name="availMode"
              id="availNow"
              value="now"
              [(ngModel)]="availMode"
            />
            <label class="form-check-label" for="availNow">Available now</label>
          </div>

          <div class="form-check form-check-inline">
            <input
              class="form-check-input"
              type="radio"
              name="availMode"
              id="availDate"
              value="date"
              [(ngModel)]="availMode"
            />
            <label class="form-check-label" for="availDate"
              >Available from date</label
            >
          </div>
        </div>

        <!-- NOW mode -->
        <div *ngIf="availMode === 'now'" class="row g-2 align-items-center">
          <div class="col-auto">
            <label class="col-form-label">Notice period</label>
          </div>
          <div class="col">
            <select class="form-select" [(ngModel)]="availDurationId">
              <option [ngValue]="null">Select duration</option>
              <option
                *ngFor="let d of availabiltyDurations"
                [ngValue]="d.duration_id"
              >
                {{ d.value }}
              </option>
            </select>
          </div>
          <div class="col-auto">
            <button
              class="btn btn-primary btn-sm btn-lite-blue"
              (click)="saveAvailabilityInline()"
              [disabled]="savingAvailability"
            >
              <span *ngIf="!savingAvailability">Save</span>
              <span
                *ngIf="savingAvailability"
                class="spinner-border spinner-border-sm"
              ></span>
            </button>
          </div>
        </div>

        <!-- DATE mode -->
        <div *ngIf="availMode === 'date'" class="row g-2 align-items-center">
          <div class="col-auto">
            <label class="col-form-label">Start date</label>
          </div>
          <div class="col">
            <input
              type="date"
              class="form-control"
              [(ngModel)]="availStartAt"
            />
          </div>
          <div class="col-auto">
            <button
              class="btn btn-primary btn-sm btn-lite-blue"
              (click)="saveAvailabilityInline()"
              [disabled]="savingAvailability"
            >
              <span *ngIf="!savingAvailability">Save</span>
              <span
                *ngIf="savingAvailability"
                class="spinner-border spinner-border-sm"
              ></span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="modal-footer border-0 pt-0">
    <button class="btn btn-secondary" (click)="cancelPreApply()">Close</button>
    <button
      class="btn btn-primary btn-lite-blue"
      (click)="continueAfterFixes()"
      [disabled]="needsPhone || needsCv || needsAvailability"
    >
      Continue
    </button>
  </div>
</ng-template>

<!-- Apply Confirmation Modal -->
<ng-template #applyConfirmModal let-modal>
  <div class="modal-header border-0 pb-0">
    <h5 class="modal-title fw-semibold">Confirm Application</h5>
    <button
      type="button"
      class="btn-close"
      (click)="cancelApply()"
      aria-label="Close"
    ></button>
  </div>

  <div class="modal-body">
    <p class="text-muted mb-3">
      You’re about to apply to this job. Add a short note (optional) before
      sending.
    </p>

    <label class="form-label fw-semibold"
      >Message to recruiter (optional)</label
    >
    <textarea
      [(ngModel)]="applyMessage"
      class="form-control apply-textarea"
      rows="4"
      maxlength="1000"
      placeholder="Example: Hi! I'm interested in this role. My availability is immediate."
    ></textarea>
    <small class="text-muted d-block text-end mt-1"
      >{{ applyMessage.length || 0 }}/1000</small
    >

    <div
      class="alert alert-info d-flex align-items-center gap-2 mt-3 apply-note"
    >
      <i class="bi bi-info-circle"></i>
      Your application will be only visible to the job owner.
    </div>
  </div>

  <div class="modal-footer border-0 pt-0">
    <button class="btn btn-secondary" (click)="cancelApply()">Cancel</button>
    <button class="btn btn-primary btn-lite-blue" (click)="confirmApply()">
      Confirm & Apply
    </button>
  </div>
</ng-template>

<!-- Share Modal -->
<ng-template #shareModal let-modal>
  <div class="modal-header border-0 pb-0">
    <h5 class="modal-title fw-semibold">Share this post</h5>
    <button type="button" class="btn-close" (click)="modal.dismiss()"></button>
  </div>

  <div class="modal-body">
    <div class="mb-3">
      <label class="form-label">Heading (you can edit)</label>
      <input
        type="text"
        class="form-control"
        [(ngModel)]="shareHeading"
        (ngModelChange)="onShareHeadingInput()"
        maxlength="80"
        placeholder="Found this and thought of you"
      />
      <small class="text-muted"
        >Max ~80 chars is a good length for most apps.</small
      >
    </div>

    <div class="mb-2">
      <label class="form-label">Preview message</label>

      <div class="share-preview card border-0 shadow-sm">
        <div class="share-preview__header">
          <div class="share-preview__title">
            <i class="bi bi-chat-right-dots"></i>
            Message Preview
          </div>
          <div class="share-preview__actions">
            <span class="share-preview__length"
              >{{ composedMessage.length || 0 }} chars</span
            >
            <button
              type="button"
              class="btn btn-sm btn-dark rounded-pill px-3"
              (click)="copyShareText()"
              title="Copy to clipboard"
            >
              <i class="bi bi-clipboard"></i> Copy
            </button>
          </div>
        </div>

        <div class="share-preview__body">
          <pre class="share-preview__text">{{ composedMessage }}</pre>
        </div>
      </div>
    </div>

    <div class="d-flex flex-wrap gap-2 my-3">
      <button
        class="btn btn-primary btn-sm d-flex align-items-center gap-2"
        *ngIf="canUseWebShare"
        (click)="shareNative()"
      >
        <i class="bi bi-share"></i>
        <span>Share via device…</span>
      </button>

      <ng-container *ngFor="let t of shareTargets">
        <a
          *ngIf="t.href; else btnTarget"
          class="btn btn-outline-secondary btn-sm d-flex align-items-center gap-2"
          [href]="t.href"
          target="_blank"
          rel="noopener"
        >
          <i *ngIf="t.iconClass" class="bi" [ngClass]="t.iconClass"></i>
          <span>{{ t.label }}</span>
        </a>

        <ng-template #btnTarget>
          <button
            class="btn btn-outline-secondary btn-sm d-flex align-items-center gap-2"
            type="button"
            (click)="openShareTarget(t)"
          >
            <i *ngIf="t.iconClass" class="bi" [ngClass]="t.iconClass"></i>
            <span>{{ t.label }}</span>
          </button>
        </ng-template>
      </ng-container>
    </div>
  </div>

  <div class="modal-footer border-0 pt-0">
    <button class="btn btn-secondary" (click)="modal.close()">Close</button>
  </div>
</ng-template>
